import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import FormGenerator from '@sharedCR/common/formGenerator';
import PropTypes from 'prop-types';

import { DRAWER_MESSAGES } from '../../LoanEditorCustomFormDrawer.constants';
import {
  formGroupStyles,
  sectionDescriptionStyles,
  sectionStyles,
  sectionTitleStyles,
} from '../../LoanEditorCustomFormDrawer.styles';
import { getColumnCountForLayout } from '../../LoanEditorCustomFormDrawer.utils';
import DrawerCustomFieldsGroup from '../DrawerCustomFieldsGroup';

const DrawerFieldsSection = ({
  section,
  loanFieldGroups,
  customFieldResolutions,
  customFieldsController,
  formState,
  mergedPendingChanges,
  handleChange,
  setInForm,
  staticValidateField,
  validateField,
  validationErrors,
  disabled,
}) => {
  const columnCount = getColumnCountForLayout(section.layout);

  return (
    <Box sx={sectionStyles}>
      <Box sx={sectionTitleStyles}>
        <Typography variant="bold14">
          {section.title || DRAWER_MESSAGES.UNTITLED_SECTION}
        </Typography>
      </Box>

      {!!section.description && (
        <Typography color="textSecondary" sx={sectionDescriptionStyles} variant="regular12">
          {section.description}
        </Typography>
      )}

      {loanFieldGroups.map(({ formName, config }) => (
        <Box key={formName} sx={formGroupStyles}>
          <FormGenerator
            isNestedForm
            changedFields={mergedPendingChanges}
            config={config}
            form={formState}
            formName={formName}
            handleChange={handleChange}
            isLoading={disabled}
            numberOfColumns={columnCount}
            pendingChanges={mergedPendingChanges}
            setInForm={setInForm}
            staticValidateField={staticValidateField}
            validateField={validateField}
            validationErrors={validationErrors}
          />
        </Box>
      ))}

      <DrawerCustomFieldsGroup
        controller={customFieldsController}
        disabled={disabled}
        numberOfColumns={columnCount}
        resolutions={customFieldResolutions}
        title={DRAWER_MESSAGES.CUSTOM_FIELDS_GROUP_TITLE}
      />
    </Box>
  );
};

DrawerFieldsSection.propTypes = {
  section: PropTypes.shape({
    layout: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  loanFieldGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  customFieldResolutions: PropTypes.arrayOf(PropTypes.object).isRequired,
  customFieldsController: PropTypes.object.isRequired,
  formState: PropTypes.object.isRequired,
  mergedPendingChanges: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  setInForm: PropTypes.func.isRequired,
  staticValidateField: PropTypes.func.isRequired,
  validateField: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  validationErrors: PropTypes.object,
};

export default memo(DrawerFieldsSection);
